<template>
  <header class="settings-section-header">
    <div class="settings-section-header__main">
      <div v-if="icon" class="settings-section-header__icon" aria-hidden="true">
        <i :class="['pi', icon]" />
      </div>
      <div class="settings-section-header__text">
        <h2 class="settings-section-header__title">{{ title }}</h2>
        <p v-if="subtitle" class="settings-section-header__subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div v-if="$slots.actions" class="settings-section-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script setup>
defineOptions({ name: 'SettingsSectionHeader' });

defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: ''
  }
});
</script>

<style scoped>
.settings-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--crc-panel-border, var(--surface-border));
  flex-shrink: 0;
}

.settings-section-header__main {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  min-width: 0;
}

.settings-section-header__icon {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--crc-green-soft, rgba(29, 158, 117, 0.12));
  color: var(--crc-green, #1d9e75);
  flex-shrink: 0;
}

.settings-section-header__title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--crc-text, var(--text-color));
  line-height: 1.3;
}

.settings-section-header__subtitle {
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
  color: var(--crc-text-muted, var(--text-color-secondary));
  line-height: 1.4;
}

.settings-section-header__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  flex-wrap: wrap;
}
</style>
